module.exports = __webpack_public_path__ + "media/images/comment-a8762f55c8b81d32f226f4f7003729d1.png";